var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.2,
    height: 19.2,
    viewBox: "0 0 19.2 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(-1237.023 -70.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M1253.414,73.107a9.6,9.6,0,1,0,0,13.583A9.615,9.615,0,0,0,1253.414,73.107Zm-2.83,9.621a.8.8,0,1,1-1.132,1.132l-2.829-2.83-2.829,2.829a.8.8,0,0,1-1.132-1.132l2.829-2.829-2.829-2.829a.8.8,0,0,1,1.131-1.132l2.83,2.829,2.829-2.829a.8.8,0,1,1,1.132,1.132l-2.83,2.829Z",
    fill: "#6c5b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ed262508624ceecdfd5e9a522a98e38f.svg";
export { ForwardRef as ReactComponent };